import { DeviceType, SupportedDeviceType } from '../types';
import { HEALTHDOT_DEVICE_BARCODE_FORMAT, VIQTOR_UDI_DEVICE_BARCODE_FORMAT } from './constants';

export { HEALTHDOT_DEVICE_BARCODE_FORMAT, VIQTOR_UDI_DEVICE_BARCODE_FORMAT };

export function getFrontendDeviceBarcodeFormats(
  supportedDeviceTypes: SupportedDeviceType[] = [DeviceType.Healthdot, DeviceType.ViQtor],
): string[] {
  const formats: string[] = [];

  if (supportedDeviceTypes.includes(DeviceType.Healthdot)) {
    formats.push(HEALTHDOT_DEVICE_BARCODE_FORMAT);
  }

  if (supportedDeviceTypes.includes(DeviceType.ViQtor)) {
    formats.push(VIQTOR_UDI_DEVICE_BARCODE_FORMAT);
  }

  return formats;
}
